/* eslint-disable indent */
import styled, { css } from 'styled-components/macro';
import Icon from './Icon';
import {
  maxWidthDefault,
  marginDesktop,
  marginDefault,
  contentMaxWidthMedia,
  colorByProp,
  marginTableMobile,
  marginTableDefault
} from '../styles/utils';
import { ActionRowButtons } from '../App/Merchants/MerchantRegistrations/ImportCsv/FailedMerchants/FailedMerchantStyles';

export const ModelListDiv = styled.div`
  /* margin: 3rem 0; */
  min-height: 350px;
  display: flex;
  flex-direction: column;

  /* Removed defaultDropShadow in favor of:*/
  border: ${props => props.theme.defaultBorder};
    padding: 3rem 0rem;
  @media screen and (min-width: 768px) {
    /* margin: 0 ${marginDefault}; */
    /* margin: 3rem 4.5rem; */
    max-width: ${maxWidthDefault - 160}px;
    ${props =>
      props.withPagination &&
      css`
        padding-bottom: 4rem;
      `}
  }

  @media screen and (min-width: 1440px) {
    /* margin: 0 ${marginDesktop}; */
  }
`;

export const ModelListTable = styled.table`
  width: 100%;
  margin-bottom: 7rem;
  tr {
    td,
    th {
      border-bottom: ${props => props.theme.defaultBorder};
    }
  }
  ${props =>
    props.hideHeaderBorder &&
    css`
      thead > tr th {
        border-bottom: none;
      }
    `}
  ${props =>
    props.formActive &&
    css`
      th {
        color: ${props => props.theme.dustierGray};
      }
    `}
      ${props =>
        props.marginBottom &&
        css`
          margin-bottom: 2rem;
        `}
    ${props =>
      props.summaryTableStyles &&
      css`
        tr {
          td {
            border-bottom: none;
          }
        }
      `}
    ${props =>
      props.smallMarginBottom &&
      css`
        margin-bottom: 1.1rem;
        @media screen and (min-width: 768px) {
          margin-bottom: 1.8rem;
        }
      `}
  
`;

const cellStyles = css`
  padding: 15px 5px;
  ${props =>
    props.center &&
    css`
      text-align: center;
    `}

  ${props =>
    props.width &&
    css`
      width: ${props.width};
    `}
  ${props =>
    props.right
      ? css`
          padding-right: 10px;
          text-align: right;
          &:nth-last-child(2) {
            padding-right: 0;
          }
        `
      : css`
          padding-left: 10px;
          &:nth-child(2) {
            padding-left: 0;
          }
        `}
  ${props =>
    props.rightMobile &&
    css`
      @media screen and (max-width: 767px) {
        text-align: right;
      }
    `}
  ${colorByProp}
  ${props =>
    props.capitalize &&
    css`
      text-transform: capitalize;
    `}
  ${props =>
    props.firstCapital &&
    css`
      &::first-letter {
        text-transform: uppercase;
      }
    `}
  ${props =>
    props.summaryTableStyles &&
    css`
      padding: 5px;
    `}
`;

export const ModelListTh = styled.th`
  ${cellStyles}
  /* ${props => props.thFilter && css``} */
  ${props =>
    props.formActive &&
    css`
      color: ${props => props.theme.dustierGray};
    `}
  ${props =>
    props.perPage &&
    css`
      padding: 10px 3px;
      text-align: right;
    `}
  ${props =>
    props.summaryTableHeader &&
    css`
      &&& {
        padding: 5px 5px 10px 5px;
      }
    `}
 
`;

export const ModelListTd = styled.td`
  /* cursor: default; */
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  max-width: 400px;
  > svg, > img {
    margin-right: 1.3rem;
  }
  
  ${cellStyles}
  line-height: 1.5rem;
  @media screen and (max-width: 767px) {
    max-width: 100px;
  }
  ${props =>
    props.wrap &&
    css`
      white-space: pre-wrap;
      padding: 3px;
      vertical-align: middle;
      word-wrap: break-word;
      ${contentMaxWidthMedia`
        max-width: 300px;
        `}
    `}
    ${props =>
      props.overflow &&
      css`
        overflow: unset;
      `}
      ${props =>
        props.visibleLink &&
        css`
          &&& > a {
            display: unset;
          }
        `}
      @media screen and (min-width: 768px) {
        max-width: 300px;
      }
      @media screen and (min-width: 1024px) {
        ${contentMaxWidthMedia`
        max-width: 260px;
        `}
    }

    ${props =>
      props.summaryTableStyles &&
      css`
        ${cellStyles} {
          padding: 5px;
        }
      `}
    ${props =>
      props.noBorder &&
      css`
        && {
          border-bottom: 0;
        }
      `}
`;

export const ReactivateSVG = styled(Icon)`
  width: 12px;
  margin-right: 5px;
`;

export const SpacerTd = styled.td`
  width: ${marginTableMobile};
  &&& {
    border-bottom: none;
  }
  @media screen and (min-width: 768px) {
    width: ${marginTableDefault};
  }
`;

const hoverStyles = css`
  &:hover {
    color: ${props => props.theme.dustyGray};
    cursor: pointer;
  }
`;

export const ModelRowTr = styled.tr`
    /* ======REMOVE ?===== */
  ${props =>
    props.hoverStylesLg &&
    !(props.highlighted || props.expandedLg) &&
    hoverStyles}
  @media screen and (max-width: 1023px) {
    ${props => props.hoverStylesDevice && !props.highlighted && hoverStyles}
  }
  @media screen and (max-width: 767px) {
    ${props =>
      props.hoverStylesMobile &&
      !(props.highlightedMobile || props.highlighted) &&
      hoverStyles}
  }
  /* =========== */
  ${props => props.hoverStyles && !props.highlighted && hoverStyles};
  ${props =>
    props.inactive &&
    css`
      color: ${props => props.theme.dustierGray};
    `}
    ${props =>
      props.inactiveRow &&
      css`
        color: ${props => props.theme.dustierGray};
      `}
  &&& {
    ${props =>
      props.expandedLg &&
      css`
        background-color: ${props => props.theme.concrete};
        td {
          border-bottom-color: transparent;
        }
      `}
    ${props =>
      props.hideBorder &&
      css`
        td {
          border-bottom-color: transparent;
        }
      `}

    @media screen and (max-width: 1023px) {
      ${props =>
        props.hideBorderDevice &&
        css`
          td {
            border-bottom-color: transparent;
          }
        `}
    ${props =>
      props.expandedDevice &&
      css`
        background-color: ${props => props.theme.concrete};
        td {
          border-bottom-color: transparent;
        }
      `}
   
    }

    @media screen and (max-width: 1439px) {
      ${props =>
        props.highlighted &&
        css`
          background-color: ${props => props.theme.concrete};
        `}
      ${props =>
        props.expanded &&
        css`
          td {
            border-bottom-color: transparent;
          }
        `}
    }

    @media screen and (max-width: 767px) {
      ${props =>
        props.expandedMobile &&
        css`
          background-color: ${props => props.theme.concrete};
        `}
      ${props =>
        props.highlightedMobile &&
        css`
          td {
            border-bottom-color: transparent;
          }
          td:nth-child(2) {
            &::after {
              top: 100%;
              left: 20px;
            }
          }
        `}
        ${props =>
          props.hideBorderMobile &&
          css`
            td {
              border-bottom-color: transparent;
            }
          `}
    }
  }
  @media screen and (min-width: 1024px) {
    ${ActionRowButtons} {
        display: none;
    }
    &:hover {
      ${ActionRowButtons} {
        display: unset;
      }
    }
  }
  ${props =>
    props.totalSummaryRow &&
    css`
      ${ModelSummaryRowTd} {
        padding-top: 10px;
        border-top: 1px solid ${props => props.theme.mercury};
      }
    `}
  ${props =>
    props.firstEdgeRow &&
    css`
      ${ModelListTd} {
        ${cellStyles} {
          padding: 15px 5px 5px 5px;
        }
      }
    `}
  ${props =>
    props.lastEdgeRow &&
    css`
      ${ModelListTd} {
        ${cellStyles} {
          padding: 5px 5px 15px 5px;
        }
      }
    `}
`;

export const SpacerDiv = styled.div`
  display: inline-block;
  height: ${props => props.height || '2rem'};
  border-right: ${props => props.theme.defaultBorder};
  @media screen and (max-width: 767px) {
    height: ${props => props.mobileHeight};
    ${props =>
      props.mobileHidden &&
      css`
        display: none;
      `}
  }
  @media screen and (min-width: 768px) {
    ${props =>
      props.mobileOnly &&
      css`
        display: none;
      `}
  }
`;

const desktopActionsWidth = '250px';
export const ModelRowActionsTd = styled(ModelListTd)`
  @media screen and (min-width: 1024px) {
    width: ${desktopActionsWidth};
  }
  padding: 12px 3px;
  a {
    vertical-align: middle;
  }
`;

export const ModelSummaryRowTd = styled(ModelListTd)`
  ${cellStyles} {
    padding: 5px;
  }
  && {
    border-bottom: none;
  }
  ${props =>
    props.bold &&
    css`
      && {
        font-weight: 500;
      }
    `}

  ${props =>
    props.overflow &&
    css`
      overflow: unset;
    `}
`;

export const ActionRowTr = styled.tr`
  background-color: ${props => props.theme.concrete};
  &&& td {
    border-bottom: none;
  }
`;

export const ActionRowDiv = styled.div`
  display: flex;
  /* justify-content: space-around; */
  align-items: center;
  /* padding: 1rem 0; */
  a,
  button {
    padding: 1.3rem 3rem;
  }
  svg {
    fill: black;
    margin-right: 0.5rem;
  }
`;

export const EditFormTr = styled.tr`
  td {
    background-color: ${props => props.theme.concrete};
  }
`;

export const EditFormTd = styled.td`
  &&& {
    background-color: ${props => props.theme.concrete};
    padding: 0;
    border: none;
    form {
      padding: 1rem 2rem;
    }
  }
`;

export const EditIcon = styled(Icon)`
  height: 1.2rem;
  margin-right: 1rem;
  fill: ${props => props.theme.blue};
`;

export const CheckmarkIcon = styled(Icon)`
  fill: ${props => props.theme.blue};
  height: 0.8rem;
`;

export const DeleteIcon = styled(Icon)`
  fill: ${props => props.theme[props.colorName]};
  height: 1.2rem;
`;
